(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      '[data-cart-page-qty-increase], [data-cart-page-qty-decrease], [data-cart-page-remove]'
    );
    if (!button) return;

    const page = button.closest('[data-cart-page]');
    const row = button.closest('[data-cart-line-item]');
    if (!page || !row || row.classList.contains('is-updating')) return;

    const quantityElement = row.querySelector('[data-cart-page-qty]');
    const currentQuantity = Number.parseInt(quantityElement.textContent, 10);
    let quantity = 0;

    if (button.hasAttribute('data-cart-page-qty-increase')) quantity = currentQuantity + 1;
    if (button.hasAttribute('data-cart-page-qty-decrease')) quantity = Math.max(currentQuantity - 1, 1);

    row.classList.add('is-updating');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: row.dataset.lineKey, quantity, sections: 'main' })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Cart update failed');
        return response.json();
      })
      .then((cart) => {
        const html = cart.sections && cart.sections.main;
        const updatedPage = html
          ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-page]')
          : null;

        if (!updatedPage) {
          window.location.reload();
          return;
        }

        page.innerHTML = updatedPage.innerHTML;
        document.querySelectorAll('[data-cart-count]').forEach((count) => {
          count.textContent = cart.item_count;
        });
      })
      .catch(() => {
        row.classList.remove('is-updating');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('.bc-product-form').forEach((form) => {
    const picker = form.querySelector('[data-variant-picker]');
    if (!picker) return;

    const variants = JSON.parse(form.querySelector('[data-variant-data]').textContent);
    const selects = Array.from(picker.querySelectorAll('select[data-option-position]'));
    const variantId = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-add-to-cart]');
    const price = form.closest('[data-product-section]').querySelector('[data-product-price]');

    const applyVariant = (variant) => {
      variantId.value = variant ? variant.id : '';
      button.disabled = !variant || !variant.available;
      button.textContent = variant && variant.available
        ? button.dataset.availableLabel
        : button.dataset.unavailableLabel;

      if (variant) {
        selects.forEach((select, index) => {
          select.value = variant.options[index];
        });
        if (price) price.textContent = variant.price;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    };

    selects.forEach((select, changedIndex) => {
      select.addEventListener('change', () => {
        const selectedOptions = selects.map((item) => item.value);
        let variant = variants.find((item) =>
          item.options.every((value, index) => value === selectedOptions[index])
        );

        if (!variant || !variant.available) {
          variant = variants.find((item) =>
            item.available && item.options[changedIndex] === select.value
          );
        }

        applyVariant(variant);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
